import type { FinancialProduct } from '../ovComponents/4-module/widgets/holdings/holdings.resources';
import type { Account } from './account';
import type { CustodianConnection } from './custodianConnection';
import type { Currencies } from './transaction';

export enum CustodianActivityTransactionTypes {
  EFT = 'EFT',
  BUY = 'BUY',
  SELL = 'SELL',
  CXLBUY = 'CXLBUY',
  CXLSELL = 'CXLSELL',
  MGT = 'MGT',
  CXLMGT = 'CXLMGT',
  DIV = 'DIV',
  DIS = 'DIS',
  CXLDIV = 'CXLDIV',
  WITHHOLDING_TAX = 'WDH',
  WITHHOLDING_TAX_QC = 'WHQ',
  TFI = 'TFI',
  TFO = 'TFO',
  TFR = 'TFR',
  MFV = 'MFV',
  NSF = 'CXLEFT',
  INTERNAL_DEPOSIT_TRANSFER = 'DEP',
  INTERNAL_WITHDRAW_TRANSFER = 'WDL',
  BOR = 'BOR',
  FEE = 'FEE',
  INT = 'INT',
  REF = 'REF',
  GST = 'GST',
  HST = 'HST',
  CUSTODIAN_FEE = 'CST',
  GRT = 'GRT',
  NCW = 'NCW',
  PSE = 'PSE',
  EAP = 'EAP',
  WOF = 'WOF',
  LCG = 'LCG',
  SCG = 'SCG',
  CXLPSE = 'CXLPSE',
  CXLEAP = 'CXLEAP',
  CHQ = 'CHQ',
  HBP = 'HBP',
  ACR = 'ACR',
  CLB = 'CLB',
  COM = 'COM',
  DAP = 'DAP',
  EGT = 'EGT',
  LLP = 'LLP',
  HPB = 'HPB',
  WIR = 'WIR',
  ROC = 'ROC',
  MFQ = 'MFQ',
  RED = 'RED',
  REB = 'REB',
  DRF = 'DRF',
  MDR = 'MDR',
  CXLCHQ = 'CXLCHQ',
  CXLDEP = 'CXLDEP',
  CXLFEE = 'CXLFEE',
  CXLHST = 'CXLHST',
  CXLINT = 'CXLINT',
  CXLREB = 'CXLREB',
  CXLTFI = 'CXLTFI',
  CXLTFO = 'CXLTFO',
  CXLTFR = 'CXLTFR',
  CXLMFV = 'CXLMFV',
}

export enum CustodianActivityStates {
  CREATED = 'CREATED',
  RECONCILED = 'RECONCILED',
}

export type CustodianActivity = {
  id: string;
  processDate?: Date;
  effectiveDate?: Date;
  settleDate?: Date;
  account?: Account;
  custodianConnection?: CustodianConnection;
  custodianAccountNumber: string;
  clientName?: string;
  transactionId?: string;
  subTransactionId: string;
  symbol?: string;
  cusip?: string;
  financialProduct?: FinancialProduct;
  transactionDesc?: string;
  transactionType: string;
  quantity?: number;
  commission?: string;
  priceCents?: number;
  accruedInterest?: string;
  amountValueCents: number;
  securityType?: string;
  currency?: Currencies;
  state: CustodianActivityStates;
  parseDate?: Date;
  taxes?: { taxAmountCents?: number; type?: string }[];
  associatedAccounts?: Account[];
  withholdingTaxAmountCents?: number;
};
